import $ from 'jquery'

const SELECTOR_DEFAULT = 'select.chosen-select'
const SELECTOR_STRICT = 'select.chosen-select-strict'

const startsWithMatcher = (params, data) => {
    const term = $.trim(params.term || '').toLowerCase()

    if (!term) {
        return data
    }

    if (!data.text) {
        return null
    }

    return data.text.toLowerCase().startsWith(term) ? data : null
}

function getPlaceholder($element, options = {}) {
    return $element.data('placeholder')
        || $element.attr('placeholder')
        || options.placeholder_text
        || '~'
}

function isInitialized($element) {
    return $element.hasClass('select2-hidden-accessible')
}

function destroy($element) {
    if (isInitialized($element)) {
        $element.select2('destroy')
    }
    if ($element[0]) {
        delete $element[0].chosen
    }
}

function buildOptions($element, options = {}) {
    const strictSearch = options.search_contains === false || $element.is(SELECTOR_STRICT)
    const multiple = $element.prop('multiple')

    return {
        width: options.width || '100%',
        language: 'ru',
        placeholder: getPlaceholder($element, options),
        allowClear: multiple ? false : options.allow_single_deselect !== false,
        minimumResultsForSearch: options.disable_search_threshold ?? 10,
        matcher: strictSearch ? startsWithMatcher : undefined,
    }
}

function init($element, options = {}) {
    destroy($element)
    $element.select2(buildOptions($element, options))

    if ($element[0]) {
        $element[0].chosen = $element
    }

    return $element
}

function refresh($element) {
    const select2 = $element.data('select2')

    if (select2) {
        select2.options.set('placeholder', getPlaceholder($element))
    }

    $element.trigger('change.select2')
}

$.fn.chosen = function (options) {
    if (options === 'destroy') {
        this.each(function () {
            destroy($(this))
        })
        return this
    }

    this.each(function () {
        init($(this), options || {})
    })

    return this
}

$(document).on('chosen:updated', `${SELECTOR_DEFAULT}, ${SELECTOR_STRICT}`, function () {
    const $element = $(this)

    if (!isInitialized($element)) {
        init($element)
        return
    }

    refresh($element)
})

$(document).on('chosen:destroy', `${SELECTOR_DEFAULT}, ${SELECTOR_STRICT}`, function () {
    destroy($(this))
})

function chosenRebuild() {
    $(SELECTOR_DEFAULT).chosen({
        disable_search_threshold: 10,
        placeholder_text: '~',
        width: '100%',
        allow_single_deselect: true,
        search_contains: true,
    })

    $(SELECTOR_STRICT).chosen({
        disable_search_threshold: 10,
        placeholder_text: '~',
        width: '100%',
        allow_single_deselect: true,
        search_contains: false,
    })
}

chosenRebuild()
